var _defs, _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsitesSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "websites-search-icon_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".websites-search-icon_svg__cls-1{fill:#010101;stroke-width:0}.websites-search-icon_svg__cls-3{fill:#e84b0f}.websites-search-icon_svg__cls-3,.websites-search-icon_svg__cls-4,.websites-search-icon_svg__cls-5{stroke:#010101;stroke-miterlimit:10;stroke-width:2px}.websites-search-icon_svg__cls-4{fill:#fff}.websites-search-icon_svg__cls-5{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.34 33.05c1.16 11.7-8.59 21.45-20.29 20.29-8.66-.86-15.66-7.86-16.52-16.52-1.16-11.7 8.59-21.45 20.29-20.29 8.66.86 15.66 7.86 16.52 16.52z",
    fill: "#f9d8cd",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-5",
    d: "M36.07 16.66v37.57M24.76 20.45l11.13 14.77M18.01 30.27l36.12 10.36M18.53 42.18l35.08-13.46M26.12 51.38l19.9-31.86"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "websites-search-icon_svg__cls-4",
    cx: 36.07,
    cy: 35.17,
    r: 9.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-3",
    d: "M36.07 31.68c-1.28-1.28-3.31-1.28-4.55 0-1.28 1.28-1.28 3.31 0 4.55l4.55 4.55 4.55-4.55c1.28-1.28 1.28-3.31 0-4.55s-3.28-1.24-4.55 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-1",
    d: "M32.73 11.8h1.31v4.25h-1.31z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-3",
    d: "M39.41 20.18h-6.68v-4.8l3.34-3.1 3.34 3.1v4.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-5",
    d: "M31.94 16.11l4.13-3.83 4.13 3.83"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-1",
    d: "M35.04 17.02h2.06v2.88h-2.06zM32.73 49.69h1.31v4.25h-1.31z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-3",
    d: "M39.41 58.07h-6.68v-4.8l3.34-3.1 3.34 3.1v4.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-5",
    d: "M31.94 54l4.13-3.83L40.2 54"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-1",
    d: "M35.04 54.91h2.06v2.85h-2.06zM14.94 25.1h1.31v4.25h-1.31z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-3",
    d: "M21.65 33.47h-6.71v-4.79l3.37-3.1 3.34 3.1v4.79z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-5",
    d: "M14.18 29.41l4.13-3.83 4.13 3.83"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-1",
    d: "M17.27 30.32h2.06v2.85h-2.06z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-1",
    d: "M50.98 36.82h1.31v4.25h-1.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-3",
    d: "M57.69 45.2h-6.71v-4.8l3.34-3.1 3.37 3.1v4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-5",
    d: "M50.22 41.13l4.1-3.83 4.16 3.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-1",
    d: "M53.32 42.04h2.06v2.88h-2.06z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-1",
    d: "M22.41 45.87h1.31v4.25h-1.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-3",
    d: "M29.09 54.24h-6.68v-4.79l3.34-3.1 3.34 3.1v4.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-5",
    d: "M21.62 50.17l4.13-3.82 4.13 3.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-1",
    d: "M24.71 51.09h2.06v2.85h-2.06z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-1",
    d: "M44.66 15.2h1.31v4.25h-1.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-3",
    d: "M51.34 23.58h-6.68v-4.8l3.34-3.1 3.34 3.1v4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-5",
    d: "M43.87 19.51L48 15.68l4.13 3.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-1",
    d: "M46.97 20.42h2.06v2.88h-2.06z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-1",
    d: "M21.43 14.44h1.31v4.25h-1.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-3",
    d: "M28.11 22.82h-6.68v-4.8l3.34-3.1 3.34 3.1v4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-5",
    d: "M20.64 18.72l4.13-3.8 4.13 3.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-1",
    d: "M23.74 19.63h2.06v2.88h-2.06z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-1",
    d: "M50.22 24.97h1.31v4.25h-1.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-3",
    d: "M56.9 33.35h-6.68v-4.82l3.34-3.07 3.34 3.07v4.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-5",
    d: "M49.43 29.25l4.13-3.79 4.13 3.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-1",
    d: "M52.53 30.16h2.06v2.85h-2.06z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-1",
    d: "M14.18 36.66h1.31v4.25h-1.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-3",
    d: "M20.89 45.07h-6.71v-4.82l3.34-3.1 3.37 3.1v4.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-5",
    d: "M13.39 40.97l4.13-3.82 4.16 3.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-1",
    d: "M16.49 41.89h2.06v2.88h-2.06z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-5",
    d: "M41.87 43.07l1.79 2.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-search-icon_svg__cls-4",
    transform: "rotate(-36 46.074 48.843)",
    d: "M44.24 44.74h3.67v8.23h-3.67z"
  }))));
}
export default SvgWebsitesSearchIcon;